import { TipoOrdem } from "src/app/core/model/enum/tipo-ordem.enum";


export class OrdemTextUtil {
  static getTituloByTipoOrdem(tipoOrdem: TipoOrdem, isPlural = false): string {
    switch (tipoOrdem) {
      case TipoOrdem.HISTORICO:
      case TipoOrdem.CEND:
        return isPlural ? 'Consultados' : 'Consultado';
      case TipoOrdem.OUTROS:
        return isPlural
          ? 'Pessoas sobre as quais recai a ordem'
          : 'Pessoa sobre quem recai a ordem';
      default:
        return isPlural ? 'Devedores' : 'Devedor';
    }
  }

  static getTextoConfirmacaoByTipoOrdem(tipoOrdem: TipoOrdem): string[] {
    switch (tipoOrdem) {
      case TipoOrdem.ACAO:
        return ['Confirmar inclusão da dívida?'];
      case TipoOrdem._ATUALIZACAO_ACAO:
        return ['Confirmar atualização da dívida?'];
      case TipoOrdem.BAIXA:
        return ['Confirmar baixa da dívida?'];
      case TipoOrdem.HISTORICO:
        return ['Confirmar consulta de histórico?'];
      case TipoOrdem.CEND:
        return ['<b>Confirmar consulta de endereço?</b>', 'Seu atendimento está sendo direcionado para a fila de processamento, o que pode levar alguns minutos. O fluxo atual garante maior rastreabilidade e segurança nas ações.'];
      case TipoOrdem.REVOGACAO:
        return ['Confirmar reinclusão da dívida?'];
      default:
        return ['Confirmar envio da ordem?'];
    }
  }

  static getAcaoByTipoOrdem(tipoOrdem: TipoOrdem): string {
    switch (tipoOrdem) {
      case TipoOrdem.ACAO:
        return 'Incluir Dívida';
      case TipoOrdem._ATUALIZACAO_ACAO:
        return 'Atualizar Dívida';
      case TipoOrdem.BAIXA:
        return 'Baixar Dívida';
      case TipoOrdem.CEND:
        return 'Consultar Endereço';
      case TipoOrdem.HISTORICO:
        return 'Consultar Histórico';
      case TipoOrdem.REVOGACAO:
        return 'Reincluir Dívida';
      default:
        return 'Enviar Ordem';
    }
  }

}
